import { apiConstants } from './shared/config';

const authAccess = { roles: [], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado' };

const routes = [
    {
        path: `/${apiConstants.code}/:appCode/home`,
        name: `${apiConstants.code}.home`,
        props: true,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-home" */ `./views/home.vue`),
        meta: {
            auth: undefined, //authAccess,
            hideHeaderName: true,
            title: 'home.title',
        }
    },
    {
        path: `/${apiConstants.code}/:appCode/settings`,
        name: `${apiConstants.code}.settings`,
        props: true,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'settings.titles',
        }
    },
    {
        path: `/${apiConstants.code}/:appCode/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/${apiConstants.code}/:appCode/defaultlayers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.default_layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.titles`,
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.default_layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.default_layers.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-defaultlayers" */ './views/defaultlayer/DefaultLayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `default_layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `default_layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/:appCode/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {default: true, isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `layers.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `layers.titles`,
        }
    },
    {
        path: `/${apiConstants.code}/:appCode/regulations`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-regulations" */ './views/regulation/RegulationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.regulations`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-regulations" */ './views/regulation/RegulationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.titles`,
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.regulations.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-regulations" */ './views/regulation/RegulationDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'item'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`,
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.regulations.show.group`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-regulations" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`,
                }
            },
            {
                path: 'item/:id',
                name: `${apiConstants.code}.regulations.show.item`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-regulations" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `regulations.title`,
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `regulations.titles`,
        }
    },


    {
        path: `/${apiConstants.code}/:appCode/pages`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pages" */ "./views/page/PageBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.pages`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pages" */ "./views/page/PageList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.pages.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pages" */ "./views/page/PageDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`
                }
            },
            {
                path: ":slug/preview",
                name: `${apiConstants.code}.pages.preview`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-SinglePage" */ "./views/page/SinglePage.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.pages.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pages" */ "./views/page/PageDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `pages.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `pages.titles`
        }
    },
    {
        path: `/${apiConstants.code}/:appCode/pagecategories`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pagecategories" */ "./views/pagecategory/PageCategoryBase.vue"),
        children: [
            {
                path: "/",
                name: `${apiConstants.code}.page_categories`,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pagecategories" */ "./views/pagecategory/PageCategoryList.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `page_categories.titles`
                }
            },
            {
                path: "add",
                name: `${apiConstants.code}.page_categories.create`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pagecategories" */ "./views/pagecategory/PageCategoryDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `page_categories.title`
                }
            },
            {
                path: ":id",
                name: `${apiConstants.code}.page_categories.show`,
                props: true,
                component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "genericapplicationgestao-pagecategories" */ "./views/pagecategory/PageCategoryDetails.vue"),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: `page_categories.title`
                }
            }
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: `page_categories.titles`
        }
    }
];

export default routes;
